<app-device-settings-header *ngIf="controlService?.isVisualAidCall"
  [title]="callStore.getCall()?.callName"
/>
<div class="content" *ngIf="deviceSettingsService">
  <div class="content-frame" [class.fit-content]="deviceSettingsService.isPermissionDismissedAudio || deviceSettingsService.isPermissionDismissedVideo">
    <div class="title">{{'settings.DEVICE_SETUP_INTRO' | transloco}}</div>
    <div class="sub-title">{{'settings.MICROPHONE_REQUIRED_NOTICE' | transloco}}</div>
    <app-device-settings-content [deviceSettingsService]="deviceSettingsService" *ngIf="!controlService?.isVisualAidCall" (diagnosticRunningChange)="onDiagnosticRunningChange($event)" />
    <app-visual-aid-device-settings-content [deviceSettingsService]="deviceSettingsService" *ngIf="controlService?.isVisualAidCall" (diagnosticRunningChange)="onDiagnosticRunningChange($event)" />
<div class="information" [ngClass]="{ 'visual-aid': controlService?.isVisualAidCall }">
      <div *ngIf="deviceSettingsService.isDeviceBlocked">
        {{'settings.DEVICE_ENABLE_INSTRUCTIONS' | transloco}}
      </div>
      <div class="columns">
        <div>
          {{'settings.ENABLE_CAMERA' | transloco}}
          <div class="links">
            <a href="https://support.microsoft.com/en-us/windows/manage-app-permissions-for-your-camera-in-windows-87ebc757-1f87-7bbf-84b5-0686afb6ca6b"
              target="_blank">{{'settings.WINDOWS_USERS' | transloco}}</a>
            <a href="https://support.apple.com/guide/mac-help/control-access-to-your-camera-mchlf6d108da/mac"
              target="_blank">{{'settings.MAC_USERS' | transloco}}</a>
            <a href="https://support.apple.com/guide/ipad/control-access-to-hardware-features-ipade3312ebe/ipados"
              target="_blank">{{'settings.IPAD_USERS' | transloco}}</a>
          </div>
        </div>
        <div>
          {{'settings.ENABLE_MICROPHONE' | transloco}}
          <div class="links">
            <a href="https://support.microsoft.com/en-us/windows/turn-on-app-permissions-for-your-microphone-in-windows-10-94991183-f69d-b4cf-4679-c98ca45f577a"
              target="_blank">{{'settings.WINDOWS_USERS' | transloco}}</a>
            <a href="https://support.apple.com/guide/mac-help/control-access-to-the-microphone-on-mac-mchla1b1e1fe/mac"
              target="_blank">{{'settings.MAC_USERS' | transloco}}</a>
            <a href="https://support.apple.com/guide/ipad/control-access-to-hardware-features-ipade3312ebe/ipados"
              target="_blank">{{'settings.IPAD_USERS' | transloco}}</a>
          </div>
        </div>
        <div>
          {{'settings.ENABLE_DEVICES_BY_BROWSER' | transloco}}
          <div class="links">
            <a href="https://support.google.com/chrome/answer/2693767?hl=en&co=GENIE.Platform%3DiOS"
              target="_blank">{{'settings.CHROME_USERS' | transloco}}</a>
            <a href="https://support.apple.com/guide/mac-help/control-access-to-your-camera-mchlf6d108da/mac"
              target="_blank">{{'settings.SAFARI_USERS' | transloco}}</a>
            <a href="https://support.mozilla.org/en-US/kb/how-manage-your-camera-and-microphone-permissions#:~:text=If%20you've%20turned%20off,submenu%20for%20the%20Firefox%20app."
              target="_blank">{{'settings.FIREFOX_USERS' | transloco}}</a>
            <a href="https://support.microsoft.com/en-us/windows/windows-camera-microphone-and-privacy-a83257bc-e990-d54a-d212-b5e41beba857#:~:text=In%20Microsoft%20Edge%2C%20select%20Settings,Permissions%2C%20select%20Camera%20or%20Microphone."
              target="_blank">{{'settings.EDGE_USERS' | transloco}}</a>
          </div>
        </div>
      </div>
    </div>
  </div>

</div>
<footer *ngIf="deviceSettingsService" class="footer-device-settings">
  <quant-button type="button" hierarchy="primary-disabled-dark" size="lg"
    [label]="controlService?.isVisualAidCall ? ('settings.START_CALL_BUTTON' | transloco) : (isAudioOnly ? ('settings.START_WITHOUT_CAMERA_BUTTON' | transloco) : ('settings.START_CALL_BUTTON' | transloco))"
    [disabled]="!deviceSettingsService.audioDeviceSelected || isDiagnosticRunning"
    [matTooltipDisabled]="!!deviceSettingsService.audioDeviceSelected" matTooltipClass="unavailable-tooltip"
    [matTooltip]="'settings.MICROPHONE_REQUIRED_WARNING' | transloco" (click)="handleStartCallClick()">
  </quant-button>
</footer>
